/* KAV · eventos anonimos del storefront para las animaciones en vivo.
   Manda dos cosas: que alguien entro (visit) y que agrego algo al carrito (cart).
   Las compras NO se mandan desde aca: salen de los pedidos reales en el servidor.
   No envia datos personales, solo un id de sesion anonimo y la ruta.

   El tema agrega al carrito con un formulario real:
     <form method="post" action="/cart/add" data-type="add-to-cart-form">
   Por eso el enganche principal es el evento "submit" de ese formulario,
   capturado en fase de captura para que corra antes de que el tema lo procese. */
(function () {
  var TOKEN = "kav_live_5c1f8a37e2b94d06ab7f";
  var ENDPOINT = "https://kav-influencers.higgsfield.app/api/store/beacon";
  var ultimoEnvio = { cart: 0, remove: 0 };

  function sid() {
    try {
      var k = "kav_sid";
      var v = sessionStorage.getItem(k);
      if (!v) {
        v = Math.random().toString(36).slice(2) + Date.now().toString(36);
        sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) {
      return "anon";
    }
  }

  function send(kind, extra) {
    try {
      // Ni un carrito ni un retiro se mandan dos veces por la misma accion.
      if (kind === "cart" || kind === "remove") {
        var ahora = Date.now();
        if (ahora - ultimoEnvio[kind] < 2000) return;
        ultimoEnvio[kind] = ahora;
      }
      var payload = { kind: kind, sid: sid(), path: location.pathname };
      if (extra) for (var key in extra) payload[key] = extra[key];
      var body = JSON.stringify(payload);
      var url = ENDPOINT + "?k=" + encodeURIComponent(TOKEN);
      fetch(url, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: body,
        keepalive: true,
      }).catch(function () {
        // Respaldo: beacon con texto plano, que no dispara preflight.
        try {
          if (navigator.sendBeacon) navigator.sendBeacon(url, body);
        } catch (e) {}
      });
    } catch (e) {}
  }

  // Entrada a la pagina
  send("visit");

  // 1) Enganche principal: el formulario nativo de agregar al carrito del tema.
  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== "FORM") return;
      var accion = form.getAttribute("action") || "";
      var tipo = form.getAttribute("data-type") || "";
      if (accion.indexOf("/cart/add") > -1 || tipo === "add-to-cart-form") send("cart");
    },
    true,
  );

  // 2) El clic sobre el boton de agregar del formulario del tema. Es la senal mas
  //    directa del usuario y no depende de como el tema procese el envio.
  document.addEventListener(
    "click",
    function (event) {
      var objetivo = event.target;
      if (!objetivo || !objetivo.closest) return;
      var boton = objetivo.closest('button[name="add"], button[type="submit"], .product-form__submit, [data-add-to-cart]');
      if (!boton) return;
      var form = boton.closest("form");
      if (!form) return;
      var accion = form.getAttribute("action") || "";
      if (accion.indexOf("/cart/add") > -1) send("cart");
    },
    true,
  );

  // 2) Tambien sirve si el tema dispara el submit por codigo (form.requestSubmit()).
  try {
    var requestSubmit = HTMLFormElement.prototype.requestSubmit;
    if (requestSubmit) {
      HTMLFormElement.prototype.requestSubmit = function () {
        try {
          var accion = this.getAttribute("action") || "";
          if (accion.indexOf("/cart/add") > -1) send("cart");
        } catch (e) {}
        return requestSubmit.apply(this, arguments);
      };
    }
  } catch (e) {}

  // 3) Quitar del carrito. El tema avisa con "cart:updated" cuando cambia el carrito
  //    (pagina del carrito, donde quitar es poner la cantidad en cero) y con
  //    "cartdrawer:opened" cuando se abre el cajon. En vez de adivinar por el DOM,
  //    se compara el estado real del carrito: si baja la cantidad de articulos, se quito.
  var ultimoConteo = null;
  function revisarCarrito() {
    try {
      fetch("/cart.js", { cache: "no-store" })
        .then(function (res) {
          return res.json();
        })
        .then(function (carrito) {
          var n = Number((carrito && carrito.item_count) || 0);
          if (ultimoConteo === null) {
            ultimoConteo = n;
            return;
          }
          if (n < ultimoConteo) send("remove");
          ultimoConteo = n;
        })
        .catch(function () {});
    } catch (e) {}
  }
  document.addEventListener("cart:updated", revisarCarrito);
  document.addEventListener("cartdrawer:opened", revisarCarrito);
  revisarCarrito();

  // 3) Ultimo respaldo: si algun script agregara sin formulario.
  try {
    var original = window.fetch;
    if (original) {
      window.fetch = function (input, init) {
        try {
          var url = typeof input === "string" ? input : (input && input.url) || "";
          if (url.indexOf("/cart/add") > -1) send("cart");
        } catch (e) {}
        return original.apply(this, arguments);
      };
    }
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (String(url).indexOf("/cart/add") > -1) send("cart");
      } catch (e) {}
      return open.apply(this, arguments);
    };
  } catch (e) {}
})();
